import React from 'react';
import { useRouter } from 'next/router';
import cx from 'classnames';

import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

import { SubtopicType } from 'libs/contentful/types';

import styles from './SubtopicChips.module.less';

type SubtopicChipsProps = {
  subtopics: SubtopicType[];
  topicHref: string;
};

const SubtopicChips: React.FC<SubtopicChipsProps> = ({ subtopics, topicHref }) => {
  const { asPath } = useRouter();

  if (!subtopics.length) return null;

  return (
    <div className={styles.container}>
      <ButtonV3
        className={cx(styles.chip, {
          [styles.activeChip]: asPath === topicHref,
        })}
        component="a"
        href={topicHref}
        variant="secondary"
      >
        <>All</>
      </ButtonV3>
      {subtopics.map(subtopic => {
        const subtopicHref = `${topicHref}/${subtopic.slug || ''}`;
        return (
          <ButtonV3
            className={cx(styles.chip, {
              [styles.activeChip]: asPath?.includes(subtopicHref),
            })}
            component="a"
            href={subtopicHref}
            key={subtopic.slug}
            variant="secondary"
          >
            <>{subtopic.name}</>
          </ButtonV3>
        );
      })}
      <div className={styles.spacer} />
    </div>
  );
};
export default SubtopicChips;
